import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsString, Length } from 'class-validator';

export class UploadCertificadoDigitalDto {
  @ApiProperty({ example: '123456' })
  @IsNotEmpty({ message: 'PIN es obligatorio' })
  @IsString()
  @Length(1, 50, { message: 'PIN debe tener entre 1 y 50 caracteres' })
  pin: string;
}
